import { useBooleanFlag } from "@apac/feature-flags";
import {
  usePriceDisplay as useCorePriceDisplay,
  type UsePriceDisplayParams,
  type UsePriceDisplayResponse,
} from "@b2bportal/core-ui/overridable";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FeatureFlagNames } from "@hsbc/utilities";

export const usePriceDisplay = (
  params: UsePriceDisplayParams
): UsePriceDisplayResponse => {
  const showMerchandisingPayWithPointsPrice = useBooleanFlag(
    FeatureFlagNames.SHOW_MERCHANDISING_PAY_WITH_POINTS_PRICE
  );
  const corePriceDisplay = useCorePriceDisplay(params);
  const { formatFiatCurrency } = useI18nContext();

  if (!showMerchandisingPayWithPointsPrice) {
    return corePriceDisplay;
  }

  const priceText = formatFiatCurrency(params.prices.fiat, {
    ...params.formatOptions,
  });

  return {
    priceText,
    rewardsText: "",
    combinedText: priceText,
    showRewardPrice: false,
  };
};
